let handled = false;

const handleMouseAndTouchEvents = (e) => {
	if (e.type === 'touchend') {
		handled = true;
		updateCurrentClass(e.target);
	} else if (e.type === 'mouseup' && !handled) {
		updateCurrentClass(e.target);
	} else {
		handled = false;
	}
};

const updateCurrentClass = (clickedElement) => {
	// Check if the clicked element or its parent has a specific class
	const targetElement = clickedElement.closest(
		'.block-quick-links__link-wrapper'
	);
	if (targetElement) {
		// Remove 'current' class from all elements
		document
			.querySelectorAll('.block-quick-links__link-wrapper.current')
			.forEach((el) => {
				el.classList.remove('current');
			});

		// Add 'current' class to the clicked element
		targetElement.classList.add('current');
	}
};

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);
